import React, { useEffect, useState } from 'react'
import Header from '../components/home/Header'
import ValoresApi from '../services/robinhood/ValoresApi';
import ContentBox from '../components/ContentBox';
import MunicipioSelecionado from '../components/extratos/MunicipioSelecionado';
import MunicipioSelecionarModal from '../components/municipios/MunicipioSelecionarModal';
import ContentBoxValores from '../components/extratos/ContentBoxValores';
import RelatorioChart from '../components/extratos/RelatorioChart';
import TransferenciasGlobaisAnos from '../components/transferenciasGlobais/TransferenciasGlobaisAnos';
import Preloader from '../components/home/Preloader';
import { useLocation } from 'react-router-dom';

export default function ExtratoRelatorio() {
    const location = useLocation();
    const anoRequest = location.state ? location.state.ano : new Date().getFullYear();
    const [ano, setAno] = useState(anoRequest);
    const [valores, setValores] = useState({});
    const [valoresIndices, setValoresIndices] = useState({ valores: {}, totalMeses: {} });
    const [valoresTransferencias, setValoresTransferencias] = useState({ valores: {}, totalMeses: {} });
    const [valoresDadosBasicos, setValoresDadosBasicos] = useState({ valores: {}, totalMeses: {} });
    const [valoresSaneamento, setValoresSaneamento] = useState({ valores: {}, totalMeses: {} });
    const [valoresConservacao, setValoresConservacao] = useState({ valores: {}, totalMeses: {} });
    const [anos, setAnos] = useState([]);
    let municipioStorage = JSON.parse(localStorage.getItem('municipio'));
    const [municipio, setMunicipio] = useState(municipioStorage);

    let municipio_id = localStorage.getItem('municipio_id');
    const categorias = { 'indices': 1, 'transferencias': 2, 'dados_basicos': 3, 'saneamentos': 4, 'conservacoes': 5 };

    useEffect(() => {
        getValores(ano);
    }, [ano]);

    useEffect(() => {
        setAno(new Date().getFullYear());
        getValores(ano);
    }, [municipio_id]);


    const getValores = async (_ano) => {
        municipio_id = localStorage.getItem('municipio_id');
        setValoresIndices({ valores: {}, totalMeses: {} });
        setValoresTransferencias({ valores: {}, totalMeses: {} });
        setValoresDadosBasicos({ valores: {}, totalMeses: {} });
        setValoresSaneamento({ valores: {}, totalMeses: {} });
        setValoresConservacao({ valores: {}, totalMeses: {} });
        // setAnos([]);

        new ValoresApi().relatorio(municipio_id, ano, categorias.indices).then(response => {
            if (response.valores)
                setValoresIndices({ 'valores': response.valores, 'totalMeses': response.totalMeses });
        });
        new ValoresApi().relatorio(municipio_id, ano, categorias.transferencias).then(response => {
            setValoresTransferencias({ 'valores': response.valores, 'totalMeses': response.totalMeses });
        });
        new ValoresApi().relatorio(municipio_id, ano, categorias.dados_basicos).then(response => {
            setValoresDadosBasicos({ 'valores': response.valores, 'totalMeses': response.totalMeses });
        });
        // new ValoresApi().relatorio(_municipio_id, ano, categorias.saneamentos).then(response => {
        //     setValoresSaneamento({ 'valores': response.valores, 'totalMeses': response.totalMeses });
        // });
        // new ValoresApi().relatorio(_municipio_id, ano, categorias.conservacoes).then(response => {
        //     setValoresConservacao({ 'valores': response.valores, 'totalMeses': response.totalMeses });
        // });
        new ValoresApi().anos().then(response => {
            setAnos(response.reverse());
        });

        scrollWindow();
    }
    const handlerMunicipio = (_municipio) => {
        setMunicipio(_municipio)
    }

    const drawTable = (_valores) => {
        return Object.entries(_valores).map(([key, values], i) => {
            let total = { "ano": 0.00000000 };
            Object.entries(values).map(([mes, valor], j) => {
                let nValor = null;
                if (valor) {
                    nValor = String(valor).replace(',', '.');
                    if (typeof parseFloat(nValor) === "number")
                        total.ano = parseFloat(total.ano) + parseFloat(nValor);
                }
            });
            return <>
                <tr key={Math.random()}>
                    <td className='text-left'>{key}</td>
                    {Object.entries(values).map(([mes, valor], j) => <td className='text-right'>{valor}</td>)}
                    <td className='text-right bg-light'>{String(total.ano).replace('.', ',')}</td>
                </tr>
            </>
        });
    }

    const filtrarMeses = (_totalMeses) => {
        const meses = [];
        Object.entries(_totalMeses).map(([key, value], i) => {
            key == 'JANEIRO' && meses.push(value)
            key == 'FEVEREIRO' && meses.push(value)
            key == 'MARÇO' && meses.push(value)
            key == 'ABRIL' && meses.push(value)
            key == 'MAIO' && meses.push(value)
            key == 'JUNHO' && meses.push(value)
            key == 'JULHO' && meses.push(value)
            key == 'AGOSTO' && meses.push(value)
            key == 'SETEMBRO' && meses.push(value)
            key == 'OUTUBRO' && meses.push(value)
            key == 'NOVEMBRO' && meses.push(value)
            key == 'DEZEMBRO' && meses.push(value)
        })
        return meses;
    }

    const drawFooter = (_totalMeses, _bgColor) => {
        const meses = filtrarMeses(_totalMeses);
        return <>
            <tr key={Math.random()}>
                <td class={`text-left ${_bgColor}`}>TOTAL <small style={{ fontSize: '8px' }}>(MENSAL)</small></td>
                {meses.map((mes) => <td className='text-right bg-light'> {mes} </td>)}
                <td></td>
            </tr>
        </>
    }

    const drawHeader = (_valores, _totalMeses, _bgColor) => {
        return <>
            <table class="table table-sm small table-hover" key={Math.random()} >
                <thead>
                    <th class="text-left">INDICADOR</th>
                    <th class="text-right">JANEIRO</th>
                    <th class="text-right">FEVEREIRO</th>
                    <th class="text-right">MARÇO</th>
                    <th class="text-right">ABRIL</th>
                    <th class="text-right">MAIO</th>
                    <th class="text-right">JUNHO</th>
                    <th class="text-right">JULHO</th>
                    <th class="text-right">AGOSTO</th>
                    <th class="text-right">SETEMBRO</th>
                    <th class="text-right">OUTUBRO</th>
                    <th class="text-right">NOVEMBRO</th>
                    <th class="text-right">DEZEMBRO</th>
                    <th class={`text-right ${_bgColor}`}>TOTAL <small style={{ fontSize: '8px' }}>(ANUAL)</small></th>
                </thead>
                <tbody>
                    {drawTable(_valores)}
                    {drawFooter(_totalMeses, _bgColor)}

                </tbody>
            </table>
        </>
    }

    const handlerAno = (_ano) => {
        // setValoresIndices({ valores: {}, totalMeses: {} });
        // setValoresTransferencias({ valores: {}, totalMeses: {} });
        // setValoresDadosBasicos({ valores: {}, totalMeses: {} });
        // setValoresSaneamento({ valores: {}, totalMeses: {} });
        // setValoresConservacao({ valores: {}, totalMeses: {} });
        setAno(_ano);
    }

    const scrollWindow = () => {
        let mybutton = document.getElementById("buttomScrollUp");
        window.onscroll = function () { scrollFunction() };
        function scrollFunction() {
            if (document.documentElement.scrollTop > 60) {
                mybutton.style.display = "block";
            } else {
                mybutton.style.display = "none";
            }
        }
    }

    const topFunction = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return <>
        <Header>
            <h5 style={{ marginLeft: '20px', marginBottom: '20px' }}> <i className='zmdi zmdi-city-alt'></i> EXTRATO COMPARATIVO MENSAL DO ANO DE {ano} </h5>
            <section className='container-fluid'>
                <div className='row'>
                    <MunicipioSelecionado municipio={municipio} />
                    <TransferenciasGlobaisAnos anos={anos} handlerAno={handlerAno} backgroundColor={'bg-blue-grey'} />

                </div>
            </section>
        </Header>

        <section className='content' style={{ marginTop: '-10px' }}>

            {Object.entries(valoresIndices.valores).length == 0 && Object.entries(valoresTransferencias.valores).length == 0 && Object.entries(valoresDadosBasicos.valores).length == 0 && Object.entries(valoresSaneamento.valores).length == 0 && Object.entries(valoresConservacao.valores).length == 0 ?
                <p>
                    <div className='text-left m-l-20 m-t-20' >
                        <Preloader color={'pl-pink'} />  <span className='text-muted blink_me' style={{ marginTop: '15px', color: '#', position: 'absolute', marginLeft: '10px' }}> AGUARDE... </span>

                    </div>
                </p>
                : null}

            {Object.entries(valoresIndices.valores).length > 0 && <ContentBoxValores titulo="INDICES" subtitulo={` EVOLUÇÃO DOS INDICES DO MUNICÍPIO DE ${municipio.municipio} DURANTE O ANO DE ${ano}`} color='yellowgreen'>
                <RelatorioChart ano={ano} dados={filtrarMeses(valoresIndices.totalMeses)} label={''} titulo={''} subtitulo={''} backgroundColor={'#8BC34A'} key={Math.random()} />
                {/* <br /> */}
                {drawHeader(valoresIndices.valores, valoresIndices.totalMeses, 'bg-light-green')}
            </ContentBoxValores>}

            {Object.entries(valoresTransferencias.valores).length > 0 && <ContentBoxValores titulo="TRANSFERENCIAS" subtitulo={` EVOLUÇÃO DAS TRANSFERENCIAS DO MUNICÍPIO DE ${municipio.municipio} DURANTE O ANO DE ${ano}`} color='pink'>

                <RelatorioChart ano={ano} dados={filtrarMeses(valoresTransferencias.totalMeses)} label={''} titulo={''} subtitulo={''} backgroundColor={'#E91E63'} key={Math.random()} />
                {drawHeader(valoresTransferencias.valores, valoresTransferencias.totalMeses, 'bg-pink')}
            </ContentBoxValores>}

            {Object.entries(valoresDadosBasicos.valores).length > 0 && <ContentBoxValores titulo="DADOS BASICOS" subtitulo={` EVOLUÇÃO DOS DADOS BASICOS DO MUNICÍPIO DE ${municipio.municipio} DURANTE O ANO DE ${ano}`} color='purple'>

                <RelatorioChart ano={ano} dados={filtrarMeses(valoresDadosBasicos.totalMeses)} label={''} titulo={''} subtitulo={''} backgroundColor={'#BA3BD0'} key={Math.random()} />
                {drawHeader(valoresDadosBasicos.valores, valoresDadosBasicos.totalMeses, 'bg-purple')}
            </ContentBoxValores>}

        </section>
        <MunicipioSelecionarModal titulo='ALTERAR MUNICÍPIO' handlerMunicipio />

        <a onClick={topFunction} id="buttomScrollUp" className='btn btn-rouded  waves-effect'>
            <i className='zmdi zmdi-caret-up-circle' style={{ marginTop: '0px', paddingTop: '-10px' }}></i>
        </a>

    </>
}